import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "My life is a derivative of a derivative",
  "description": "",
  "published": "2009-10-11T00:00:00.000Z",
  "redirect_from": ["/blog/my-life-is-a-derivative-of-a-derivative/swizec/769"],
  "categories": "food for thought, life, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Abeautifulmindposter.jpg"
          }}><img parentName="a" {...{
              "src": "https://upload.wikimedia.org/wikipedia/en/9/98/Abeautifulmindposter.jpg",
              "alt": "A Beautiful Mind (film)",
              "title": "A Beautiful Mind (film)"
            }}></img></a></p>
        <p parentName="li">{`Image via `}<a parentName="p" {...{
            "href": "http://en.wikipedia.org/wiki/Image:Abeautifulmindposter.jpg"
          }}>{`Wikipedia`}</a></p>
      </li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://en.wikipedia.org/wiki/A_Beautiful_Mind_%28film%29",
        "title": "A Beautiful Mind (film)"
      }}>{`A Beautiful Mind`}</a>{` is one of my most favouritest of movies, I never quite knew why, perhaps it's because deep down I relate with John Nash as portrayed in the movie, I certainly have always stood by his`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      